/**
 * Build a compact list of page numbers with ellipsis markers.
 *
 * Returns the first page, the current page with one neighbour on each side,
 * and the last page, inserting 'left-ellipsis' / 'right-ellipsis' tokens
 * wherever a gap exists. Example for current=3, total=12:
 *   [1, 2, 3, 4, 'right-ellipsis', 12]
 *
 * For totals ≤ 7 the full sequence is returned (no ellipsis needed).
 */
export function buildPageList(current, total) {
  const pages = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('left-ellipsis');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('right-ellipsis');
  pages.push(total);
  return pages;
}
